import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptAgencyBudgetByType } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import { Money } from '@utils/utils'
import Chart from 'react-google-charts'
import { PieChartOptions } from '@components/chart/setting'

const AgencyBudgetByType = ({ title, data }: { title: string; data: IResponseOptAgencyBudgetByType }) => {
  const options = PieChartOptions('มูลค่าโครงการ', 'ประเภทกิจกรรมบริการวิชาการ')

  const chartData = [
    ['ประเภทกิจกรรมบริการวิชาการ', 'มูลค่าโครงการ', { role: 'tooltip', type: 'string', p: { html: true } }],
    ...data.map((item) => {
      const row: (string | number)[] = []

      row.push(`${item.agency_type_name} (${item.total_projects} โครงการ)
      มูลค่าโครงการ ${Money(item.total_budget)} บาท`)
      row.push(parseFloat(item.total_budget))
      row.push(`<div style="padding:8px; width: 280px">
            <strong>${item.agency_type_name}</strong><br/>
            จำนวนโครงการ : ${item.total_projects} โครงการ<br/>
            มูลค่าโครงการ : ${Money(item.total_budget)} บาท
          </div>
        `)

      return row
    }),
  ]

  console.log(chartData)

  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Chart width={'100%'} height={'500px'} chartType="PieChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default AgencyBudgetByType
